export enum ContentDocumentType {
  HomepageHeroBase = 'homepage_hero',
  HomepageHeroBrandLove = 'tsx_homepage_hero_brand_love',
  HomepageEssentialsSection = 'tsx_homepage_essentials_section',
}
